export const getFixedQueryString = (rawQuery: string) => {
  let fixedQuery = rawQuery;

  // Match question marks which look like they should be amps
  // https://regex101.com/r/DLtEi8
  const invalidQuestionMarkRegex = /\?[^&?]+=/g;

  let invalidQuestionMark: RegExpExecArray | null;

  let maxIterations = rawQuery.length;

  while (
    // Limit the number of iterations so we prevent infinite loop
    // Láďa was scared
    maxIterations >= 0 &&
    (invalidQuestionMark = invalidQuestionMarkRegex.exec(fixedQuery)) !== null
  ) {
    const chars = fixedQuery.split('');
    chars[invalidQuestionMark.index] = '&';
    fixedQuery = chars.join('');

    maxIterations--;
  }

  return fixedQuery;
};
